import React from "react";

import { SelectList } from "@common/selectList";
import { Sorters } from "../../types";
import { DropDownList } from "./dropDownList";
import { DropDownInput } from "./dropDownInput";
import { Props } from "./types";
import styles from "./styles.scss";

function SortDropDown({ sort, setSort }: Props) {
  const sortOptions: { [key in Sorters]: string } = {
    [Sorters.None]: "projectResourcesPage.filters.noSort",
    [Sorters.Name]: "projectResourcesPage.filters.lastNameSort",
    [Sorters.Role]: "projectResourcesPage.filters.roleSort",
    [Sorters.EntryDate]: "projectResourcesPage.filters.entryDateSort",
  };

  return (
    <SelectList
      rootClassName={styles.sortDropDown}
      listClassName={styles.listRoot}
    >
      {({ isOpen, select }) => ({
        input: (
          <DropDownInput
            activeSorter={sort}
            sortOptions={sortOptions}
            isOpen={isOpen}
          />
        ),
        list: (
          <DropDownList
            select={select}
            sortOptions={sortOptions}
            activeSorter={sort}
            setActiveSorter={setSort}
          />
        ),
      })}
    </SelectList>
  );
}

export { SortDropDown };
